import Axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Alert, Button, Col, Form, Input, List, Modal, Row } from "rsuite";
import {
	AddCarToHoldOverCars,
	GetReports,
	RemoveCarFromHoldOverCars,
	SelectedCar,
	SetAllDeviceInfo,
	SetHoldOverCars,
	SetIcons,
	SetInterval,
	SetIsWithOutPoint,
	SetReportIndex,
	SetSelectedSingleCar,
} from "../../redux/cars/cars.action";
import {
	selectAllDeviceInfo,
	selectCarIcons,
	selectCarsData,
	selectHoldOverCars,
	selectInterval,
	selectIsWithOutPoint,
	selectReports,
	selectSelectedCarInfo,
	selectSingleCarData,
} from "../../redux/cars/cars.selector";
import {
	selectIconsLayer,
	selectIsLive,
	selectIsMain,
	selectMap,
	selectReportLayer,
} from "../../redux/map/map.selector";
import { selectIconModal } from "../../redux/modals/modals.selector";
import modalsTypes from "../../redux/modals/modals.types";
import { selectToken, selectUserInfo } from "../../redux/user/user.selector";
import "./cars.modal.sass";

//ICON IMPORT
import * as L from "leaflet";
import ambolancegr from "../../assets/icons/ambolance_gr.png";
import ambolanceg from "../../assets/icons/ambolance_green.png";
import ambolancer from "../../assets/icons/ambolance_red.png";
import ambolancey from "../../assets/icons/ambolance_y.png";
import bicyclegr from "../../assets/icons/bicycle_gr.png";
import bicycleg from "../../assets/icons/bicycle_green.png";
import bicycler from "../../assets/icons/bicycle_red.png";
import busgr from "../../assets/icons/bus_gr.png";
import busg from "../../assets/icons/bus_green.png";
import busr from "../../assets/icons/bus_red.png";
import busy from "../../assets/icons/bus_Y.png";
import carg from "../../assets/icons/carg.png";
import cargr from "../../assets/icons/cargr.png";
import carr from "../../assets/icons/carr.png";
import cary from "../../assets/icons/car_y.png";
import doggr from "../../assets/icons/dog_gr.png";
import dogg from "../../assets/icons/dog_green.png";
import dogr from "../../assets/icons/dog_red.png";
import metrogr from "../../assets/icons/metro_gr.png";
import metrog from "../../assets/icons/metro_green.png";
import metror from "../../assets/icons/metro_red.png";
import metroy from "../../assets/icons/metro_y.png";
import motorgr from "../../assets/icons/motor_gr.png";
import motorg from "../../assets/icons/motor_green.png";
import motorr from "../../assets/icons/motor_red.png";
import motory from "../../assets/icons/motor_y.png";
import persongr from "../../assets/icons/person_gr.png";
import persong from "../../assets/icons/person_green.png";
import personr from "../../assets/icons/person_red.png";
import shipgr from "../../assets/icons/ship_gr.png";
import shipg from "../../assets/icons/ship_green.png";
import shipr from "../../assets/icons/ship_red.png";
import shipy from "../../assets/icons/ship_y.png";
import taxigr from "../../assets/icons/taxi_gr.png";
import taxig from "../../assets/icons/taxi_green.png";
import taxir from "../../assets/icons/taxi_red.png";
import taxiy from "../../assets/icons/taxi_yl.png";
import truckgr from "../../assets/icons/truck_gr.png";
import truckg from "../../assets/icons/truck_green.png";
import truckr from "../../assets/icons/truck_red.png";
import trucky from "../../assets/icons/truck_y.png";
import vangr from "../../assets/icons/van_gr.png";
import vang from "../../assets/icons/van_green.png";
import vanr from "../../assets/icons/van_red.png";
import vany from "../../assets/icons/van_y.png";
import carsTypes from "../../redux/cars/cars.types";
import { SetIconsLayer, SetLivePath } from "../../redux/map/map.actions";
import mapTypes from "../../redux/map/map.types";
import { BiggerTime, ToPersianDate } from "../../script";

class CarsIconsModal extends React.Component {
	// search between devices will not work dont try
	// if u should i have created a bit of the functionality complete it, handleDevices
	constructor(props) {
		super(props);
	}

	render() {
		const {
			iconsModal,
			setSingleCarData,
			SetIconsLayer,
			ToggleCarsModal,
			ToggleDrawer,
			getIsLive,
			getIsMain,
			carsData,
			getUserData,
			getMap,
			GetSelectedCarData,
			selectedCarData,
			ToggleIsLive,
			ToggleIsMain,
			RemoveCarSelected,
			IconLayer,
			setReports,
			getReport,
			ClearIconsLayer,
			setLivePath,
			isMain,
			isLive,
			getReportLayer,
			ClearReportLayer,
			SetIcons,
			SetReportIndex,
			SetInterval,
			getInterval,
			getAllDeviceInfo,
			ToggleStatus,
			removeCarFromHoldOverCars,
			SetIsWithOutPoint,
			ClearHoldOverCars,
			getToken,
			setHoldOverCars,
		} = this.props;

		const dayInMS = 1000 * 60 * 60 * 24;
		const Now = Math.floor(new Date().getTime());
		const day5 = new Date(Now - dayInMS * 5).getTime();
		const day3 = new Date(Now - dayInMS * 3).getTime();

		const handleExit = () => {
			let map = getMap;
			if (getIsLive) {
				ToggleIsLive();
			}
			if (!getIsMain) {
				ToggleIsMain();
			}
			RemoveCarSelected();
			IconLayer.map((item) => map.removeLayer(item));
			ClearIconsLayer();
			getReportLayer.map((item) => map.removeLayer(item));
			ClearReportLayer();
			ToggleCarsModal();
			setReports([]);
			SetReportIndex(0);
			if (getInterval) {
				clearInterval(getInterval);
				SetInterval(0);
			}

			carsData.map((car) => {
				let markersLayer;
				let iconUrl = carg;

				//SWITCH
				switch (car.Application) {
					case 0:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = carr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = cargr;
						} else if (car.Switch) {
							iconUrl = cary;
						} else {
							iconUrl = carg;
						}
						break;
					case 1:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = vanr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = vangr;
						} else if (car.Switch) {
							iconUrl = vany;
						} else {
							iconUrl = vang;
						}
						break;
					case 2:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = truckr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = truckgr;
						} else if (car.Switch) {
							iconUrl = trucky;
						} else {
							iconUrl = truckg;
						}
						break;
					case 3:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = taxir;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = taxigr;
						} else if (car.Switch) {
							iconUrl = taxiy;
						} else {
							iconUrl = taxig;
						}
						break;
					case 4:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = busr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = busgr;
						} else if (car.Switch) {
							iconUrl = busy;
						} else {
							iconUrl = busg;
						}
						break;
					case 5:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = motorr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = motorgr;
						} else if (car.Switch) {
							iconUrl = motory;
						} else {
							iconUrl = motorg;
						}
						break;
					case 6:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = bicycler;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = bicyclegr;
						} else {
							iconUrl = bicycleg;
						}
						break;
					case 7:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = shipr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = shipgr;
						} else if (car.Switch) {
							iconUrl = shipy;
						} else {
							iconUrl = shipg;
						}
						break;
					case 8:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = metror;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = metrogr;
						} else if (car.Switch) {
							iconUrl = metroy;
						} else {
							iconUrl = metrog;
						}
						break;
					case 9:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = ambolancer;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = ambolancegr;
						} else if (car.Switch) {
							iconUrl = ambolancey;
						} else {
							iconUrl = ambolanceg;
						}
						break;
					case 10:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = dogr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = doggr;
						} else {
							iconUrl = dogg;
						}
						break;
					case 11:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = personr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = persongr;
						} else {
							iconUrl = persong;
						}
						break;
					default:
						if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
							iconUrl = carr;
						} else if (
							BiggerTime(car.SimDebitLastUpdate, car.Time) <
							day3 / 1000
						) {
							iconUrl = cargr;
						} else if (car.Switch) {
							iconUrl = cary;
						} else {
							iconUrl = carg;
						}
						break;
				}

				let icon = L.icon({
					iconUrl: iconUrl,
					iconAnchor: [15, 22],
					popupAnchor: [0, -20],
					iconSize: new L.Point(30, 45),
				});

				markersLayer = new L.marker([car.Latitude, car.Longitude], {
					icon: icon,
					rotationAngle: car.COG * 30,
				});

				SetIcons(iconUrl);

				let myPopup = `
                                 <b>${car.Name}</b><br>
                                 <span>${ToPersianDate(car.Date)}</span><br/>
                                 <span>وضعیت سویچ : ${
																		car.Switch ? "باز" : "بسته"
																	}</span><br/>
                                 <span>وضعیت درب ها : ${
																		car.Door ? "باز" : "بسته"
																	}</span><br/>
                                 <span>سرعت : ${
																		car.Speed ? `${car.Speed} کیلومتر` : "ساکن"
																	}</span><br/>
                                 <span>دما : ${car.Temperature}</span><br />
                                 <span>وضعیت رله : ${
																		car.Relay ? "قطع" : "وصل"
																	}</span><br />
                        `;

				markersLayer.bindPopup(myPopup);
				map.addLayer(markersLayer);
				SetIconsLayer(markersLayer);
			});

			map.flyTo([32.951302, 53.652285], 5);
		};

		/** HANDLE SUBMIT */ /** HANDLE SUBMIT */ /** HANDLE SUBMIT */
		/** HANDLE SUBMIT */
		const handleSubmit = (id, lat, long) => {
			let map = getMap,
				user = getUserData;

			if (!getReport.length) {
				setReports([]);
			}

			IconLayer.map((item) => map.removeLayer(item));
			getReportLayer.map((item) => map.removeLayer(item));
			ClearIconsLayer();
			ClearReportLayer();
			setReports([]);
			SetReportIndex(0);
			if (getInterval) {
				clearInterval(getInterval);
				SetInterval(0);
			}

			user.id = id;

			Axios.post(`${getToken}/deviceInfo`, JSON.stringify(user)).then((res) => {
				const arr = res.data.data[0].ExpTime.split(/-|\s|:/);
				const ExpDate = new Date(
					arr[0],
					arr[1] - 1,
					arr[2],
					arr[3],
					arr[4],
					arr[5]
				);
				const currentTime = new Date();
				ClearHoldOverCars();
				if (ExpDate > currentTime) {
					GetSelectedCarData(res.data.data[0]);
					map.flyTo([lat, long], 15);

					ToggleCarsModal();

					Axios.post(`${getToken}/lastCar`, JSON.stringify(user)).then(
						(res) => {
							if (res.data.success) {
								setSingleCarData(res.data.data[0]);
								setLivePath(res.data.data);
								if (isMain) {
									ToggleIsMain();
									if (!isLive) {
										ToggleIsLive();
									}
								} else {
									if (!isLive) {
										ToggleIsLive();
									}
								}
							} else {
								Alert.error("مشکلی در گرفتن دیتا به وجود آمده", 3000);
							}
						}
					);

					if (!getReport.length) {
						setReports([]);
					}

					const car = carsData.find((x) => x.DeviceID === id);

					let markersLayer;

					let iconUrl = carg;

					//SWITCH
					switch (car.Application) {
						case 0:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = carr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = cargr;
							} else if (car.Switch) {
								iconUrl = cary;
							} else {
								iconUrl = carg;
							}
							break;
						case 1:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = vanr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = vangr;
							} else if (car.Switch) {
								iconUrl = vany;
							} else {
								iconUrl = vang;
							}
							break;
						case 2:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = truckr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = truckgr;
							} else if (car.Switch) {
								iconUrl = trucky;
							} else {
								iconUrl = truckg;
							}
							break;
						case 3:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = taxir;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = taxigr;
							} else if (car.Switch) {
								iconUrl = taxiy;
							} else {
								iconUrl = taxig;
							}
							break;
						case 4:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = busr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = busgr;
							} else if (car.Switch) {
								iconUrl = busy;
							} else {
								iconUrl = busg;
							}
							break;
						case 5:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = motorr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = motorgr;
							} else if (car.Switch) {
								iconUrl = motory;
							} else {
								iconUrl = motorg;
							}
							break;
						case 6:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = bicycler;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = bicyclegr;
							} else {
								iconUrl = bicycleg;
							}
							break;
						case 7:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = shipr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = shipgr;
							} else if (car.Switch) {
								iconUrl = shipy;
							} else {
								iconUrl = shipg;
							}
							break;
						case 8:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = metror;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = metrogr;
							} else if (car.Switch) {
								iconUrl = metroy;
							} else {
								iconUrl = metrog;
							}
							break;
						case 9:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = ambolancer;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = ambolancegr;
							} else if (car.Switch) {
								iconUrl = ambolancey;
							} else {
								iconUrl = ambolanceg;
							}
							break;
						case 10:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = dogr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = doggr;
							} else {
								iconUrl = dogg;
							}
							break;
						case 11:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = personr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = persongr;
							} else {
								iconUrl = persong;
							}
							break;
						default:
							if (BiggerTime(car.SimDebitLastUpdate, car.Time) < day5 / 1000) {
								iconUrl = carr;
							} else if (
								BiggerTime(car.SimDebitLastUpdate, car.Time) <
								day3 / 1000
							) {
								iconUrl = cargr;
							} else if (car.Switch) {
								iconUrl = cary;
							} else {
								iconUrl = carg;
							}
							break;
					}

					let icon = L.icon({
						iconUrl: iconUrl,
						iconAnchor: [15, 22],
						popupAnchor: [0, -20],
						iconSize: new L.Point(30, 45),
					});

					SetIcons(icon);

					markersLayer = new L.marker([car.Latitude, car.Longitude], {
						icon: icon,
						rotationAngle: car.COG * 30,
					});

					let myPopup = `
                                 <div id=${car.DeviceID}>
                                     <b>${car.Name}</b><br>
                                     <span>${ToPersianDate(
																				car.Date
																			)}</span><br/>
                                     <span>وضعیت سویچ : ${
																				car.Switch ? "باز" : "بسته"
																			}</span><br/>
                                     <span>وضعیت درب ها : ${
																				car.Door ? "باز" : "بسته"
																			}</span><br/>
                                     <span>سرعت : ${
																				car.Speed
																					? `${car.Speed} کیلومتر`
																					: "ساکن"
																			}</span><br/>
                                     <span>دما : ${car.Temperature}</span><br />
                                     <span>وضعیت رله : ${
																				car.Relay ? "قطع" : "وصل"
																			}</span><br />
                                 </div>
                            `;

					markersLayer.bindPopup(myPopup);

					IconLayer.map((item) => map.removeLayer(item));
					ClearIconsLayer();
					map.addLayer(markersLayer);
					SetIconsLayer(markersLayer);
				} else {
					Alert.error(
						`تارخ انقضای پنل ${res.data.data[0].NAME} به اتمام رسیده است`,
						5000
					);
					ToggleDrawer();
				}
			});
		};
		// END HANDLE SUBMIT

		const HandleExpireClick = (car) => {
			ClearHoldOverCars();
			setHoldOverCars([car.value]);
			ToggleDrawer();
		};
		const onHideHandler = () => {
			ToggleCarsModal();
			// if(carsData.length > 1 ){
			ClearHoldOverCars();
			// }
		};

		const HandleWithOutPoint = (car) => {
			let user = getUserData;
			user.id = car.DeviceID;
			Axios.post(`${getToken}/deviceInfo`, JSON.stringify(user)).then((res) => {
				const arr = res.data.data[0].ExpTime.split(/-|\s|:/);
				const ExpDate = new Date(
					arr[0],
					arr[1] - 1,
					arr[2],
					arr[3],
					arr[4],
					arr[5]
				);
				const currentTime = new Date();
				ClearHoldOverCars();
				let AllData = { ...res.data.data[0], ...car };
				SetIsWithOutPoint(AllData);
				if (ExpDate > currentTime) {
					ToggleCarsModal();
					ToggleStatus();
				} else {
					Alert.error(
						`تارخ انقضای پنل ${res.data.data[0].NAME} به اتمام رسیده است`,
						5000
					);
					ToggleDrawer();
				}
			});
		};

		// const handleDevices = (e) => {
		// 	const filteredCars = carsData.filter(({ label }) => {
		// 		return label.indexOf(e) !== -1;
		// 	});
		// 	this.setState({ shownCars: filteredCars });
		// };

		/** RETURN */ /** RETURN */ /** RETURN */ /** RETURN */ /** RETURN */ /** RETURN */ /** RETURN */
		return (
			<div className="modal-container">
				<Modal
					size="xs"
					show={iconsModal}
					onHide={() => onHideHandler()}
				>
					<Modal.Header>
						<Modal.Title className="modal-carIcon-title">
							دستگاه های موجود
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className="modal-carIcon-p">
							شما <span style={{ color: "red" }}>{carsData.length}</span> دستگاه
							در شبکه زیتونیکس دارید{" "}
						</p>

						{/* <Input
							onChange={(e) => {
								handleDevices(e);
							}}
							// value="برای جستجو نام وسیله را وارد کنید"
							placeholder="برای جستجو نام وسیله را وارد کنید..."
						/> */}

						<br />
						<List
							hover
							className="custom-list"
						>
							<Form>
								{/* {this.shownCars.map((car) => { */}
								{carsData.map((car) => {
									let iconUrl = carg;
									let thisCarInfo = getAllDeviceInfo.find(
										(item) => item.ID == car.DeviceID
									);
									//Switch
									switch (car.Application) {
										case 0:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = carr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = cargr;
											} else if (car.Switch) {
												iconUrl = cary;
											} else {
												iconUrl = carg;
											}
											break;
										case 1:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = vanr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = vangr;
											} else if (car.Switch) {
												iconUrl = vany;
											} else {
												iconUrl = vang;
											}
											break;
										case 2:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = truckr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = truckgr;
											} else if (car.Switch) {
												iconUrl = trucky;
											} else {
												iconUrl = truckg;
											}
											break;
										case 3:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = taxir;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = taxigr;
											} else if (car.Switch) {
												iconUrl = taxiy;
											} else {
												iconUrl = taxig;
											}
											break;
										case 4:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = busr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = busgr;
											} else if (car.Switch) {
												iconUrl = busy;
											} else {
												iconUrl = busg;
											}
											break;
										case 5:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = motorr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = motorgr;
											} else if (car.Switch) {
												iconUrl = motory;
											} else {
												iconUrl = motorg;
											}
											break;
										case 6:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = bicycler;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = bicyclegr;
											} else {
												iconUrl = bicycleg;
											}
											break;
										case 7:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = shipr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = shipgr;
											} else if (car.Switch) {
												iconUrl = shipy;
											} else {
												iconUrl = shipg;
											}
											break;
										case 8:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = metror;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = metrogr;
											} else if (car.Switch) {
												iconUrl = metroy;
											} else {
												iconUrl = metrog;
											}
											break;
										case 9:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = ambolancer;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = ambolancegr;
											} else if (car.Switch) {
												iconUrl = ambolancey;
											} else {
												iconUrl = ambolanceg;
											}
											break;
										case 10:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = dogr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = doggr;
											} else {
												iconUrl = dogg;
											}
											break;
										case 11:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = personr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = persongr;
											} else {
												iconUrl = persong;
											}
											break;
										default:
											if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day5 / 1000
											) {
												iconUrl = carr;
											} else if (
												BiggerTime(car.SimDebitLastUpdate, car.Time) <
												day3 / 1000
											) {
												iconUrl = cargr;
											} else if (car.Switch) {
												iconUrl = cary;
											} else {
												iconUrl = carg;
											}
											break;
									}

									return (
										<List.Item key={car.DeviceID}>
											{car.Active ? (
												// IF ACTIVE
												parseInt(car.Expire) <
												Math.floor(new Date().getTime() / 1000.0) ? (
													// IF EXPIRE
													<Row>
														<Col xs={8}>
															<div
																className="expire-div"
																onClick={() => HandleExpireClick(car)}
															>
																<span />
															</div>
														</Col>
														<Col xs={8}>
															<span className="modal-carIcon-span">
																<img
																	src={iconUrl}
																	alt="xitonix"
																	className="modal-carIcon-span-img"
																/>
															</span>
														</Col>
														<Col xs={8}>
															<span className="modal-carIcon-span">
																{car.Name}
															</span>
														</Col>
													</Row>
												) : car.Latitude && car.Longitude ? ( //orderShow
													<Row>
														<Col
															xs={12}
															onClick={() =>
																handleSubmit(
																	car.DeviceID,
																	car.Latitude,
																	car.Longitude
																)
															}
															style={{ cursor: "pointer" }}
														>
															<span className="modal-carIcon-span">
																<img
																	src={iconUrl}
																	alt="xitonix"
																	className="modal-carIcon-span-img"
																/>
															</span>
														</Col>
														<Col
															xs={12}
															onClick={() =>
																handleSubmit(
																	car.DeviceID,
																	car.Latitude,
																	car.Longitude
																)
															}
															style={{ cursor: "pointer" }}
														>
															<span className="modal-carIcon-span">
																{car.Name}
															</span>
														</Col>
													</Row>
												) : (
													<Row>
														<Col xs={8}>
															<div
																className="withOutPoint-div"
																onClick={() => HandleWithOutPoint(car)}
															>
																<span />
															</div>
														</Col>
														<Col xs={8}>
															<span className="modal-carIcon-span">
																<img
																	src={iconUrl}
																	alt="xitonix"
																	className="modal-carIcon-span-img"
																/>
															</span>
														</Col>
														<Col xs={8}>
															<span className="modal-carIcon-span">
																{car.Name}
															</span>
														</Col>
													</Row>
												)
											) : (
												//IF UnACTIVE
												<Row>
													<Col xs={8}>
														<div
															className="un-active-div"
															onClick={() =>
																Alert.error(
																	`دستگاه شما ${car.Name} غیرمجاز و غیرفعال است لطفا به نمایندگی عودت دهید . DeviceID = ${car.DeviceID}`,
																	5000
																)
															}
														>
															<span />
														</div>
													</Col>
													<Col xs={8}>
														<span className="modal-carIcon-span">
															<img
																src={iconUrl}
																alt="xitonix"
																className="modal-carIcon-span-img"
															/>
														</span>
													</Col>
													<Col xs={8}>
														<span className="modal-carIcon-span">
															{car.Name}
														</span>
													</Col>
												</Row>
											)}
										</List.Item>
									);
								})}
							</Form>
						</List>
					</Modal.Body>
					<Modal.Footer>
						{selectedCarData ? (
							<Row>
								<Col xs={24}>
									<Button
										onClick={() => handleExit()}
										className="BtnExit"
										block
									>
										خروج از {selectedCarData.NAME}
									</Button>
								</Col>
							</Row>
						) : null}
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	iconsModal: selectIconModal,
	carsData: selectCarsData,
	getMap: selectMap,
	selectedCarData: selectSelectedCarInfo,
	getUserData: selectUserInfo,
	IconLayer: selectIconsLayer,
	getSingleCarData: selectSingleCarData,
	getIcon: selectCarIcons,
	getReport: selectReports,
	getReportLayer: selectReportLayer,
	getInterval: selectInterval,
	getIsLive: selectIsLive,
	getIsMain: selectIsMain,
	isMain: selectIsMain,
	isLive: selectIsLive,
	HoldOverCars: selectHoldOverCars,
	getToken: selectToken,
	getAllDeviceInfo: selectAllDeviceInfo,
	isWithOutPoint: selectIsWithOutPoint,
});
const mapDispatchToProps = (dispatch) => ({
	ToggleCarsModal: () => dispatch({ type: modalsTypes.TOGGLE_ICONS }),
	GetSelectedCarData: (Data) => dispatch(SelectedCar(Data)),
	RemoveCarSelected: () =>
		dispatch({ type: carsTypes.REMOVE_CAR_SELECTED_INFO }),
	SetIconsLayer: (layer) => dispatch(SetIconsLayer(layer)),
	setSingleCarData: (car) => dispatch(SetSelectedSingleCar(car)),
	setReports: (reports) => dispatch(GetReports(reports)),
	ClearIconsLayer: () => dispatch({ type: mapTypes.CLEAR_ICONS_LAYER }),
	ClearReportLayer: () => dispatch({ type: mapTypes.CLEAR_REPORT_LAYER }),
	SetIcons: (icons) => dispatch(SetIcons(icons)),
	SetReportIndex: (index) => dispatch(SetReportIndex(index)),
	SetInterval: (invertal) => dispatch(SetInterval(invertal)),
	ToggleDrawer: () => dispatch({ type: modalsTypes.TOGGLE_DRAWER }),
	ToggleIsLive: () => dispatch({ type: mapTypes.TOGGLE_IS_LIVE }),
	ToggleIsMain: () => dispatch({ type: mapTypes.TOGGLE_IS_MAIN }),
	setLivePath: (livePath) => dispatch(SetLivePath(livePath)),
	addToHoldOverCars: (car) => dispatch(AddCarToHoldOverCars(car)),
	removeCarFromHoldOverCars: (car) => dispatch(RemoveCarFromHoldOverCars(car)),
	ClearHoldOverCars: () => dispatch({ type: carsTypes.CLEAR_HOLDOVER_CARS }),
	setHoldOverCars: (array) => dispatch(SetHoldOverCars(array)),
	setAllDeviceInfo: (deviceInfo) => dispatch(SetAllDeviceInfo(deviceInfo)),
	ToggleStatus: () => dispatch({ type: modalsTypes.TOGGLE_STATUS_MODAL }),
	SetIsWithOutPoint: (deviceInfo) => dispatch(SetIsWithOutPoint(deviceInfo)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarsIconsModal);
